import { Table, TableColumnsType, Typography } from 'antd'
import { GetLoyaltyPointDisbursementRequestResponseRecipients } from 'generated/api'

import { thousandSeparator } from 'helpers/numbers'

interface IProps {
  data: GetLoyaltyPointDisbursementRequestResponseRecipients[]
  loading: boolean
}

function ReceiverTable(props: Readonly<IProps>) {
  const columnsReceiver: TableColumnsType<GetLoyaltyPointDisbursementRequestResponseRecipients> = [
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nama</Typography.Text>
        </div>
      ),
      dataIndex: 'userName',
      key: 'userName',
      render: data => (
        <div className="flex flex-col" data-testid="data-userName">
          <Typography.Text className="font-medium text-gray-800">
            {data == '' ? '-' : data}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nomor Telepon</Typography.Text>
        </div>
      ),
      dataIndex: 'phoneNo',
      key: 'phoneNo',
      render: data => (
        <div data-testid="data-phoneNo" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{data}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">SawitPoin</Typography.Text>
        </div>
      ),
      dataIndex: 'point',
      key: 'point',
      render: point => (
        <div data-testid="data-point" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">
            {thousandSeparator(point)}
          </Typography.Text>
        </div>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      loading={props.loading}
      data-testid="tbl_member"
      className="table-primary table-receiver mb-2"
      columns={columnsReceiver}
      dataSource={props.data}
      pagination={false}
      rowClassName="mx-10"
      scroll={{ y: 240 }}
    />
  )
}

export default ReceiverTable
